export function initMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return

  // Avoid initializing twice
  if ((window as any).fbq) return

  const f = window as any
  const b = document as any

  const n = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const s = b.createElement('script')
  s.async = true
  s.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = b.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(s, firstScript)

  f.fbq('init', pixelId)
  f.fbq('track', 'PageView')
}
